export const PUBLISHED = 'Publicado';
export const PUBLICED_TOOLTIP = 'Produto publicado na sua loja da Inventa';
export const INVENTORY = 'Em estoque';
export const INVENTORY_TOOLTIP =
  'Variante do produto em estoque na sua loja da Inventa';
